export enum FeatureToggleEntries {
  HEADER_APP_WAFFLE = 'Header.app.waffle',
  CPT_ANALYSIS_EXPORT = 'cpt.analysis.export',
  EM_EXPORT_OPTIONS = 'em.export.options',
  HOVER_MESSAGE = 'hover.message',
  SCROLLABLE_PAYERS = 'scrollable.payers',
  RECOVERY_DASHBOARD = 'recovery.dashboard',
  DENIALS_MODAL = 'denials.modal',
  TERMINAL_DENIAL_RATE_BENCHMARK = 'terminal.denial.rate.benchmark',
  DENIALS_MODAL_REASONS = 'denials.modal.reasons',
  DENIALS_METRIC = 'denials.metric',
  DENIALS_ONTOLOGY = 'denials.ontology',
  DENIALS_CPTS_DENIED_MODAL = 'denials.cpts.denied.modal',
  NOTIFICATIONS = 'notifications',
  ENABLE_MULTIPROVIDER_SECURITY = 'enable_multiprovider_security',
  VISIT_TYPE = 'visit.type',
  PROVIDER_PERCENTILE = 'provider.percentile',
  SPECIALTY_PERFORMANCE = 'specialty.performance',
  UPDATED_FILTER_BANNER = 'updated.filter.banner',
  SHOW_CFP_COLUMNS = 'show.cfp.columns',
  SHOW_EM_MULTIPROVIDER_EXPORT = 'show.em.multiprovider.export',
  TELEHEALTH_BENCHMARKS_EM = 'telehealth.benchmarks.em',
  TELEHEALTH_BENCHMARKS_NPV = 'telehealth.benchmarks.npv',
  PROCEDURE_SUMMARY = 'procedure.summary',
  UPDATED_EXPORT = 'updated.export',
  CPT_FILTER = 'cpt.filter',
  MULTI_PROVIDER_EXPORT_SCHEDULING = 'multiprovider.export.scheduling',
  NPV_MULTI_PROVIDER_EXPORT = 'npv.multi.provider.export',
  LOCATION_MULTI_SELECT = 'location.multi.select',
  BATCH_EXPORT_EM_TREND = 'batch.export.em.trend',
  HIDE_WRVU_BY_DEPARTMENT_BENCHMARK = 'hide.wrvu.by.department.benchmark',
  HIDE_WRVU_BY_DEPARTMENT_CFTE_ADJ_WRVUS = 'hide.wrvu.by.department.cfte.adj.wrvus',
  NPV_BY_LOCATION = 'npv.by.location',
  REDESIGN_MULTIPROVIDER_EXPORT = 'redesigned.multiprovider.export',
  MULTI_PROVIDER_BENCHMARK_SELECTORS = 'multi.provider.benchmark.selectors',
  BATCH_EXPORT_WRVU_TREND = 'batch.export.wrvu.trend',
  HIDE_PROCEDURE_SUMMARY_CFTE_WRVUS = 'hide.ps.cfte.wrvus',
  HIDE_PROCEDURE_SUMMARY_CFTE_COUNT  = 'hide.ps.cfte.count',
  MPE_NPV_BY_LOCATION = 'npv.location.mpe',
  CANCEL_DELETE_SCHEDULED_EXPORTS = 'cancel.delete.scheduled.exports'
}
